module.exports = __webpack_public_path__ + "13da6aab0a.bin";